<template>
  <div style="background: #f9f9f9" class="adaptiveMobileDesignDetails">
    <div class="details flex designRequirement">
      <div class="details_left">
        <p class="currentPosition" style="display: flex;align-items: center;">
          <!-- 当前位置：设计市场>需求详情> -->
          <span style="font-size: 14px;color: #808080;"> 当前位置：</span>
          <el-breadcrumb separator=">">
            <el-breadcrumb-item :to="{ path: '/design' }">设计市场</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/designList' }">全部需求</el-breadcrumb-item>
            <span v-text="title" style="color: #808080;">教育机构品牌标志设计</span>
          </el-breadcrumb>

          <!-- <span v-text="title">教育机构品牌标志设计</span> -->
        </p>
        <div class="left_top">
          <div class="left_top_title flex">
            <div class="titleContent">
              <p class="designTitle">
                <span class="designTop" v-text="title"
                >教育机构品牌标志设计</span
                >
              </p>
              <div class="budget flex">
                <div class="flex budgetOne" :class="isMobile? 'budgetOne_mobile':''">
                  <p class="budgetOneP">预算</p>
                  <p class="budgetOneP2" v-text="money">¥ 50~200</p>
                </div>
                <div class="budgetLeft">
                  <!-- <p>需求编号：PRI202109010808000134</p> -->
                  <p>发布时间：<span v-text="pudDate">2021-10-18</span></p>
                </div>
                <div class="budgetRight">
                  <p>截止时间：<span v-text="endDate">2021-12-12</span></p>
                </div>
              </div>
            </div>
            <div class="quotedPrice" v-if="isTimeOut">
              <p><span></span></p>
              <button
                      class="isTimeOutButton"
                      v-if="isTimeOut"
                      disabled
                      style="background: #ccc"
              >
                已过期
              </button>
            </div>
            <div class="quotedPrice" v-else-if="successBut && (demand.winner == ''|| demand.winner == null || demand.winner == undefined)">
              <p>剩余报价时间: <span v-text="restTime">3</span>天</p>
              <button class="isTimeOutButton">已报价</button>
            </div>
            <div class="quotedPrice" v-else-if="(demand.winner != '' && demand.winner != null && demand.winner != undefined)">
              <p><span></span></p>
              <button class="isTimeOutButton">已确认设计师</button>

            </div>
            <div class="quotedPrice" v-else>
              <p>剩余报价时间: <span v-text="restTime">3</span>天</p>
              <button @click="getOffer">我要报价</button>

            </div>
          </div>
          <div class="left_top_mess flex" :class="isMobile? 'left_top_mess2':''">
            <ul>
              <li v-for="(item,itemIndex) in processList" :key="itemIndex"
                  :class="itemIndex <= processIndex?'active':''" >
                <div>
                  <div class="stepNum">{{ itemIndex+1 }}</div>
                  <div class="stepName">{{ item.title }}</div>
                </div>
                <div class="stepLine" v-if="itemIndex<5"></div>
              </li>
            </ul>
            <div class="left_top_share flex">
              <p v-if="like" @click="liked(uuid)">
                <i class="el-icon-star-on" style="color: #E6A23C;font-size: 24px;"></i>
                <span style="font-size: 16px;line-height: 24px">{{ likeNum }}</span>
              </p>
              <p v-if="!like" @click="liked(uuid)">
                <i class="el-icon-star-off"></i>
                <span style="font-size: 16px;line-height: 22px">{{ likeNum }}</span>
              </p>


              <!-- <div  class="social-share share-component" style="z-index: 99999999;">

              </div> -->

              <!--<p style="display:flex" class="text">
                <i class="iconfont icon-weixin">
                  <div class="choose">
                      <div class="wechat-qrcode">
                    <h4>微信扫一扫：分享</h4>
                    <div class="qrcode" title="http://122.112.239.4:30102/news/newDetails/aab1bbc0-6c2c-4a24-a6e2-8d03a19da3d8">
                      <canvas width="100" height="100" style="display: none;"></canvas>
                      <img alt="Scan me!" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAB+dJREFUeF7tne164yoQg5v7v+juE2+yIRjxSmAn25Tza0+x+RjNSAK77uXr6+v7a+C/7+/stsvl8jRKfb9qv//8fr36/7Jz6vt+bd2n+/M6XM6c3BBfo5RF9tbzAuQR4lMAcQNcD36fVp3hKttU9qrxqbJamZfORV1PFVOPraqYqqMc/1+FLEB02BS1vQSQNLuIT6n96Iorx5ulklGNccdt9b+rkAXIA9IfDQhxvaoEVUE1fytCaSUQ6VHa7jrAWk+J6k6tkAVI7rpOAYQcihI+0pakItS1Ixl67cu9j+bo9tN1WamGLED2sBwq6q5nJh6mfsjjU/89m06c7+6R3AoYrfbWHu6wfQhtEFNa+fWAuBlN2eWePdHZVNre4v60j6OvT2N6vX76LOtdALQE8+iAzvY3BMi3e2YieicTQJNK7bKzn3H7JB1TeyHqn9bca78sQHKb+1JAaDCyuVRw6dnVTLbRHsi1pzQH94iFYrNpSF0hCxAK/779VECUfSV03cohzUkriOa1ZR08razX7Fput8KUOWhBLzXEXYS7/0iPEeqgEJBdofxJgNSPcClwVNCUsQS046LKOZT9pZlNLivJ7F4luuzR3IcsQB5w/xeAkPd2KyAFVlFU0g8FkDaxRL80F6JZur+7U6cAKepyhe4MS/oRgNxtL52QutYurbDUVfU0jDKQ2lWSUGzUnEYq5p/LokEXIFpb3gpIPbjrmmjS5K4oYcr+XbdFjnF0rUSdPa2KK2R0kguQfQRadnh3/O66KFcrSOTdbD5Ta9I5uFqj9jm9ClqAFC81qOonM5C2dwFxDxfTDKVJUpaNOBSy0oq7Xc53rT6N09Mu+7R3AaLD6MaG5OBpY0gbQTrco10wubGZrJqlmnpsVTFn6WEZG/nWCQ2eCtYCZP9kskXrSFkp11O2urY5OSFNx1QVQT8nDXGdZy8GC5CGy6JNqptULsBdyqLJzFJZz2Ekbb15zuodVRzFiCqp5yDl74ccvVlyHMYCpHhRzgVAuaFZkVf8S2WfPDFMAL9eSweqaSU57ILv9roeewHyeJli1DZv+xD1ohwBQTvxI3baZQY6lEfOTCVN6o6O1pBynQuQIhq0OSb6JEp0gLQ3huQc6nZXk5LnHLRgyvRUp2gz67IIac1ThdxfA3Kzgzz4UYt26acFkkuXFKi3AkL8StnpBmH0zGsEIHJJ5HrcJHXn5pwqy+ch7iApTSxA9m6sKeoEAGnCqIYooRzl58063l4dTSuknovLCiTWNJ8FyO3TUgT6WwCpRX30HMjdGLqLJPPQyn7akNHYRL/Uf9reGm/6WydkW2kDmVJdz3xQQBYgxlcRFiCPM7NN/xRlORatJaBuFioBpXFJQHui7hy/PAlsZQ5SA0JrbLUvQDoZRKJPyTMECB0uphmfZiGJd08zaG6kKWSLVf+Jje3NsRUrPFykRbsa4Pbjujynv48AJC1TAmR0w6n4WtHA9eeuo6PrXCCJkhy9KzVv+7d6c5HOcSiTe4ErQSSKowRp9eUmAa2BjnlOAUSd9qaOwl1crQkEHAlnL/h03EMaMgqIYg2K0VYhCxD9e+xvBcRFlbJOuaL0PnI4qtLK++gUgRwcVWdKWQ79ys8zUTmTXZ1dzK8FhPYh5EjSylJZqwB2K6vlssgtzVaIk/HlvEgvmy6LxFxlbro4ohyyjC2BJACo6oniyHkShUWAkIC57apiCMjRYFC/rcqhe4huyVaPJudThbgBpyxcgDwikFZkl7KovKh8XYBJg0hDehtL0iuixdS4uJXXuw4/8edsZjZkxXPs0YqiYFF7OSelV04fZfCIVk8FhAI86orSoxKaRxmkEYpouSC3MkjER1wYnvaSwClXlgJG7s6ptI8AhJ4YUhaoMnXL293nuNf1XJWrRylNK0ociR0+MRzptMffLlAk9j2+pkqh6n0rIPXnmYgaqN0VNhJU8vq9inEBmQ08JZdbkU/GYQGyTyFl6WtqegkgatCEw6lKErpJxnUrIzUiRJ+je7KW9sSfZyIqmQGjJcgLkFtEXbvrZhu5MaIJqtwRI0FzJ0pKk89ZY1whaWBp0u7m6dcCQs6APLeyySSITsBbVVAC7lY10S7147ozZa+VJm3rUy6LOnOPQEgQqd0pcxdMSha3n5cC0kOP6IcyuHe/65B6+xcKVFoZLkCkRaq9tRapIS41USU5IF6vWYD8jRS+5KACnmrN0Y7FBboE283U9DkKVZ6aaysJFyDB7yQSoEmSKFbAB1Q0iPu8gpwLUV9yv5uxRJOkSal2UCw3yjrqj4LRoWMS0JY5SO7/0YDUf9DFQbFVbnTEcbRNbo1HoLknzK7VTpNQGaUygU77w5KpfSZ6cEzBRwFCGXwUX5I7o3lQljt7IRqjXivtR2hO5NrK5MW332dtr1sptCg3IT4OEJc63Ex3Dw/J8ais7WkeURg5O8X5I3Mpx+pV6PSHA6iCFiD7lDkVkHQfQpsrymqH2oizySAol0Xui5xm5LKos9TipYElYGc0JA3kRwCS7l+Iv10n9ORQ4C96jlZOWtUqFpSkmyE5+mtABAyZARLSXv9HBZyohdjiUEAooMTh6bEFjUftrfFGHRvRtgvUqNFpVogbADfTKVtoPGr/WEBo4XX7CMdvGQBf2KmzkMS+BCRNklTsKQY011qLWjGfPstKgVyA7H8v/smYzJ72LkAeETiiQv4AOIbXRsEnpGQAAAAASUVORK5CYII=" style="display: block;">
                    </div>
                    <div class="help">
                      &lt;!&ndash; <p>微信里点“发现”，扫一下</p> &ndash;&gt;
                      <span>微信里点“发现”，扫一下</span>
                      <span>二维码便可将本文分享至朋友圈。</span>
                    </div>
                  </div>
                  </div>

                </i>
              </p>-->
              <p class="flex">
                <share :config="config" class="shareMobile"></share>
              </p>
              <!-- <p>
                <i v-if="!demand.fabulousLike" class="iconfont"
                   style="margin-right: 8px;cursor: pointer;" @click="saveNewsFabulous">&#xe665;</i>
                <i v-if="demand.fabulousLike" class="iconfont" style="margin-right: 8px;color: #E6A23C;cursor: pointer;"
                   @click="deleteNewsFabulous">&#xe639;</i>
                <span> {{ demand.likeNumber==null?0:demand.likeNumber }} </span>
              </p> -->
            </div>
          </div>
        </div>
        <!-- 基本信息 -->
        <div class="left_center">
          <div class="center_mess">
            <p class="center_mess_title">需求详情</p>
            <div class="basicInformation">
              <div class="center_mess_box">
                <p class="mess_box_title flex"><i></i>需求分类</p>
                <div class="mess_box_details flex" v-text="demandCate">
                  <p>设计需求</p>
                  <i></i>
                  <p>艺术设计</p>
                </div>
              </div>
              <div class="center_mess_box">
                <p class="mess_box_title flex"><i></i>期望交期</p>
                <div class="mess_box_details flex">
                  <p v-text="expectDate">2021年12月12日</p>
                </div>
              </div>

              <div class="center_mess_box">
                <p class="mess_box_title flex"><i></i>交付文件类型</p>
                <div class="mess_box_details flex">
                  <p v-text="offerType">STL、</p>
                </div>
              </div>
              <div class="center_mess_box" v-if="demandType == 'MODEL'">
                <p class="mess_box_title flex"><i></i>规格尺寸</p>
                <div class="mess_box_details flex">
                  <p v-text="size">50*50*50</p>
                </div>
              </div>

            </div>
          </div>
          <div class="center_mess">
            <p class="center_mess_title">需求描述</p>
            <div class="center_mess_box">
              <div class="mess_box_details mess_box_detailshtml" v-text="des">
              </div>
              <div class="mess_box_details mess_box_detailshtml ql-editor" v-html="remark">
              </div>
              <div class="mess_box_text">
                <p v-for="(items, index) in demandAttachments" :key="index">
                  <a
                          @click="downLoadFile(items.fileUrl, items.fileName)"
                          style="color: #157efb"
                  >
                    <i class="iconfont icon-xiazai"></i>
                    {{ items.fileName }}
                  </a>
                  <!-- <span
                  title="下载"
                    style="color: #157efb"
                    @click="getFilesUrl(items.fileUrl)"
                  >
                    <i class="iconfont icon-xiazai"></i>
                    {{ items.fileName }}
                  </span> -->
                </p>
              </div>
            </div>
          </div>
          <div class="center_mess" style="margin-bottom: 0">
            <p class="center_mess_title">交易预设</p>
            <div class="center_mess_box">
              <p style="padding: 10px 0 0; margin-left: 5px">支付方式</p>
              <!-- <p style="padding: 0.1rem 0 0; margin-left: 0.05rem;font-size:0.16rem">支付方式</p> -->
              <div class="mess_box_details flex">
                <div class="payIcon">
                  <div class="payIconContent">¥</div>
                  <div class="payIconLine"></div>
                </div>
                <p>线上支付</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 参与报价设计师 -->
        <div class="left_bottom">
          <p class="left_bottom_title">参与报价设计师</p>
          <div v-if="joinList.length > 0" class="join">
            <div class="join_box"
                 :class="items.designerUuid == demand.winnerUuid ? 'join_box_active' : ''"
                 v-for="(items,index) in joinList" :key="index"
            >
              <div class="join_box_top" :class="isMobile? 'join_box_top_mobile':''">
                <div class="join_box_top_l" @click="selectedDesigner(items.designerUuid)">
                  <img :src="items.designIconUrl ? items.designIconUrl : require('../../assets/设计市场/头像1.jpeg')" alt="">
                </div>
                <div class="join_box_top_r">
                  <div class="join_box_top_user" @click="selectedDesigner(items.designerUuid)">
                    <p>{{items.designName}}</p>
                    <span v-if="items.designerUuid == demand.winnerUuid">已选中</span>
                  </div>
                  <img v-for="(item,index) in items.designerLevels" :key="index"
                       :src="item.levelIconUrl? item.levelIconUrl :require('../../assets/模型库/designIcon.png')"
                       :title="item.name"
                       style="height: 20px;margin-left: 5px;"/>
                </div>
              </div>
              <div class="join_box_bottom">
                <div class="join_box_bottom_l">
                  <p class="join_box_bottom_t">报价金额</p>
                  <p>*** 元</p>
                </div>
                <div class="join_box_bottom_r">
                  <p class="join_box_bottom_t">报价时间</p>
                  <p>{{moment(items.createTime).format('YYYY年MM月DD日')}}</p>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="join">暂无设计师参与报价</div>
        </div>

        <div class="left_bottom" ref="designOffer" v-if="(demand.winner == '' || demand.winner == null || demand.winner == undefined) && (!successBut) && (!isTimeOut) && designer">
          <p class="left_bottom_title">我要报价</p>
          <div class="bottom_input flex">
            <div class="bottom_money flex">
              <p>报&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价</p>
              <el-input
                  type="number"
                  placeholder="请输入报价金额"
                  v-model="offerForm.offer"
              ></el-input>
              <p>元</p>
            </div>
            <div class="bottom_money flex">
              <p style="margin-right: 10px">计划工期</p>
              <el-date-picker
                      :clearable="false"
                      v-model="offerForm.planDeliveryTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
              >
              </el-date-picker>
              <p style="color: #157efb">
                <i class="el-icon-date" style="font-size: 22px"></i>
              </p>
            </div>
          </div>
          <div class="bottom_tex flex">
            <p>报价说明</p>
            <textarea
                    name=""
                    id=""
                    cols="30"
                    rows="10"
                    v-model="offerForm.remark"
            ></textarea>
          </div>
          <div class="bottom_up flex">
            <p>上传附件</p>
            <el-upload
                    class="upload-demo"
                    action="/service-center/upload/file/single"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    :on-success="handleAvatarSuccess"
                    :headers="headers"
                    :file-list="fileList"
            >
              <el-button size="small" type="primary">上传附件</el-button>
              <div slot="tip" class="el-upload__tip" style="color: #ff0000">
                注意：单个附件大小不能超过2M
              </div>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </div>
          <div class="upButton">
            <button @click="demandOffer">立即提交</button>
          </div>
        </div>
      </div>
      <div class="details_right">
        <div class="right_mess">
          <img v-if="user.headUrl" :src="user.headUrl" alt="" />
          <img v-if="!user.headUrl" src="../../assets/users.png" alt="" />
          <p class="right_mess_names" v-text="user.name">三维教育</p>
          <!--<p class="right_mess_design">恒温保险的动态视觉工作室，知名动画团队</p>-->
          <button @click="startChat">立即联系</button>
        </div>
        <div class="recommendedRequirements">
          <div class="requirementsTitle">
            <div class="name">最近需求</div>
            <div class="refresh" @click="getDemandList">
              <a
                      href="javascript:void(0)"
                      style="color: #157efb; font-size: 14px"
              >换一批</a
              >
              <i class="el-icon-refresh-right"></i>
            </div>
          </div>
          <div class="requirementItem" v-for="(items, index) in demandList">
            <h4 class="rqTitle" style="width:340px">
              <a
                      href="javascript:void(0)"
                      @click="getDetailMessage(items.uuid)"
                      style="color: #157efb"
              >{{ items.title }}</a
              >
            </h4>
            <div class="rqPrice">
              <span class="tagBlue">预算</span>
              <span class="tagName">¥{{ items.money }}</span>
            </div>
            <ul class="rqDetail">
              <li>
                <div class="detailTitle" v-if="items.describe != null">
                  模型尺寸：
                </div>
                <div class="detailContent" v-if="items.describe != null">
                  {{ items.describe }}
                </div>
                <div class="detailTitle" v-if="items.describe == null">
                  需求类型：
                </div>
                <div class="detailContent" v-if="items.describe == null">
                  设计需求
                </div>
              </li>
              <li>
                <div class="detailTitle">需求描述：</div>
                <div class="detailContent detailContent2">{{ items.size }}</div>
              </li>
              <li>
                <div class="detailTitle">期望交期：</div>
                <div class="detailContent">{{ items.date }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!--聊天窗口-->
    <chat-dialog ref="chatDialogRef"></chat-dialog>
  </div>
</template>

<script>
  import {
    addDesignerOffer,
    deleteDemandFabulous,
    demandDetail,
    demandListByPage,
    similarDemandListByPage,
    designerByUserId,
    designOrderList,
    findDemandOfferList,
    getNewcurrent,
    getRongCloudUser,
    hasDesignerOffer,
    hasLiked,
    like,
    saveDemandFabulous,
    merchantCurrent
  } from "../../utils/interface";
  import axios from "axios";
  import {mapMutations, mapState} from "vuex";
  import chatDialog from "../chat/chatDialog";
  import QRCode from 'qrcodejs2';

  export async function getFile(url) {
    return await new Promise(async function (resolve, reject) {
      await axios({
        method: "get",
        url,
        responseType: "blob",
      })
              .then((data) => {
                resolve(data.data);
              })
              .catch((error) => {
                reject(error.toString());
              });
    });
  }
  export default {
    //   需求详情
    name: "designDetails",
    metaInfo () {
      return {
        title: this.metaTitle,
        meta: [{                 // set meta
          name: "keywords",
          content: this.metaKeywords,
        },
          {                 // set meta
            name: "description",
            content: this.metaDescription,
          }
        ],
      }
    },
    components: {
      chatDialog
    },
    data() {
      return {
        isMobile: false,
        config: {
          url: window.location.href,
          disabled: ['douban', 'linkedin', 'diandian', 'qq', 'qzone', 'tencent', 'google', 'twitter', 'tencent', 'weibo']
        },
        likeNum:0,
        uuid:"",
        like: false,
        loading: "",
        demand: {},
        dialogImageUrl: "",
        dialogVisible: false,
        offerForm: {},
        demandAttachments: {},
        headers: {
          Authorization: "Bearer " + this.$cookies.get("api_access_token"), //	可以是授权凭证用的参数值
        },
        user: {},
        title: null,
        money: null,
        pudDate: null,
        endDate: null,
        restTime: null,
        isTimeOut: false,
        demandCate: null,
        demandType: null,
        expectDate: null,
        offerType: null,
        size: null,
        des: null,
        remark: null,
        pNo: 1,
        pSize: 4,
        demandList: [],
        // 关于文件上传
        fileList: [],
        successBut: false,
        userMessages: {},
        designerType: '',
        designer: false,
        orderStatus: '',
        // 参与报价设计师
        joinList: [
        ],
        metaTitle:'',
        metaKeywords:'',
        metaDescription:'',
        processList: [//步骤条
          {title: '需求报价'},
          {title: '确认设计师'},
          {title: '订单支付'},
          {title: '设计中'},
          {title: '设计验收'},
          {title: '设计评价'},
        ],
        processIndex:0,
      };
    },
    computed: {
      ...mapState({
        isTokenDoor: "isTokenDoor",
        isLogin: "isLogin",
      }),
    },
    created() {
      // if (this.$isMobile()) {
      //     this.isMobile = true
      // } else {
      //     this.isMobile = false
      // }
      this.getDetailInfo();
      if(this.isLogin){
        this.hasLiked();
        this.hasOffered();
      }


    },
    mounted(){
      const that = this;
      if(this.isLogin){
        getNewcurrent()
                .then((res) => {
                  that.userMessages = res;console.log('---'+that.userMessages)
                  if(res.identity == 'ENTERPRISE' || res.identity == 'STAFF'){
                    that.designer = false;
                  }else{
                    designerByUserId(res.uuid).then((res1) => {
                      if (res1 != null && res1.status == 'PASS') {
                        that.designer = true;
                        that.designerType = res1.type;
                        console.log('--2-'+that.designerType)
                        if (res1.type == 'MODEL' && that.demandType != 'MODEL'){
                          that.designer = false;
                        } else if (res1.type == 'GRAPHIC' && that.demandType == 'MODEL'){
                          that.designer = false;
                        }

                      }
                    });
                  }

                })
                .catch((err) => {
                  console.log(err);
                });
      }

    },
    methods: {
      ...mapMutations(["isLoginVuex"]),
      // 跳转设计师详情页
      selectedDesigner(uuid){
        let routeData = this.$router.resolve({
          name: "designModel",  params: {uuid: uuid}
        });
        window.open(routeData.href, "_blank");
      },
      downLoadFile(url, fileName) {
        getFile(url).then((res) => {
          this.loading = true;
          let blob = new Blob([res], { type: "application/octet-stream" });
          console.log(window.navigator.msSaveOrOpenBlob);
          if (window.navigator.msSaveOrOpenBlob) {
            //msSaveOrOpenBlob方法返回bool值
            navigator.msSaveBlob(blob, fileName); //本地保存
            this.loading = false;
          } else {
            let link = document.createElement("a"); //a标签下载
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
            this.loading = false;
          }
        });
      },
      // 我要报价
      getOffer() {
        if(!this.isLogin){
          this.$router.push("/login")
        } else if ((this.userMessages.identity == 'ANONYMOUS' || this.userMessages.identity == 'PERSONAL') && this.designerType == ''){
          this.$confirm('您不是平台设计师，无法参与需求报价！', '提示', {
            confirmButtonText: '入驻平台设计师',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push('/designerIn')
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        } else if (this.userMessages.identity == 'ENTERPRISE'){
          this.$alert("您是平台企业用户，无法参与需求报价！", "提示", {
            confirmButtonText: "取消",
          });
          return;
        } else if (this.designerType == 'MODEL' && this.demandType != 'MODEL'){
          this.$alert("您是平台三维设计师，无法参与平面设计需求报价！", "提示", {
            confirmButtonText: "取消",
          });
          return;
        }  else if (this.designerType == 'GRAPHIC' && this.demandType == 'MODEL'){
          this.$alert("您是平台平面设计师，无法参与三维设计需求报价！", "提示", {
            confirmButtonText: "取消",
          });
          return;
        } else if(this.demand.creator == this.userMessages.uuid){
          this.$message({
            type: "info",
            message: "不能对自己发布的需求进行报价",
          });
          return;
        }else{
          let designOffer = this.$refs.designOffer;
          window.scrollTo({
            top: designOffer.offsetTop - 200,
            behavior: "smooth",
          });
        }
      },
      // 截取年月日
      getYearMonth(date) {
        date = (date + "").split(/[ ]+/);
        let result = [];
        let resultDate;
        let reg = /^(\d{4})-(\d{1,2})-(\d{1,2})$/;
        reg.exec(date[0]);
        result.push(RegExp.$1);
        result.push(RegExp.$2);
        result.push(RegExp.$3);
        resultDate = result[0] + "-" + result[1] + "-" + result[2];
        return resultDate;
      },
      hasOffered() {
        hasDesignerOffer(this.$route.params.uuid).then((res) => {
          console.log('this.successBut',this.successBut );
          if (res) {
            this.successBut = true;
          }else{
            this.successBut = false;
          }
        });
      },
      getDetailInfo() {
        demandDetail(this.$route.params.uuid).then((res) => {
          // console.log(JSON.stringify(res));
          if (res != null) {
            findDemandOfferList({uuid:res.uuid}).then((res2) => {
              if (res2 && res2.data && res2.data.length > 0) {
                this.joinList = res2.data;
              }
            });
            let params = {
              demandUuid:res.uuid,
            };
            designOrderList(params).then((res1)=>{
              if(res1 && res1.length > 0){
                this.orderStatus = res1[0].designStatus;
              }
              this.demand = res;
              this.metaTitle = res.demandName+" - 设计市场-增材云";
              this.metaKeywords = res.metaKeywords;
              this.metaDescription = res.metaDescription;
              this.uuid = res.uuid;
              this.title = res.demandName;
              // if(res.priceType == 'FIXED'){
              //   this.money = '¥' + res.lowPreAmount;
              // }else if(res.priceType == 'RANGE'){
              this.money = "¥" + res.lowPreAmount + "~" + res.highPreAmount;
              // } else{
              //   this.money = '¥' + 0;
              // }
              console.log('res',res );
              this.pudDate = res.publishTime;
              this.pudDate = this.getYearMonth(this.pudDate);
              console.log(this.pudDate);
              this.endDate = res.deadline;
              var endTime = new Date(res.deadline).getTime() / 1000 - parseInt(new Date().getTime() / 1000);
              this.restTime = parseInt(endTime / 60 / 60 / 24) + 2;        //相差天数
              this.isTimeOut =
                      new Date().getTime() > new Date(res.deadline).getTime();
              this.demandCate = res.demandTypeCn;
              this.demandType = res.demandType;
              this.getDemandList();
              this.expectDate = res.expectedDeliveryTime;
              this.offerType = res.fileType;
              if (res.demandType == "MODEL") {
                this.size =
                        res.specificationsStart + "~" + res.specificationsEnd + "cm";
              } else {
                this.size = "设计需求";
              }
              this.des = res.demandDes;
              this.remark = res.remark;
              this.user = res.user;
              this.demandAttachments = res.demandAttachments;
              this.likeNum = res.likeNum;

              if(!this.demand.winner){
                this.processIndex = 0;
              } else if(this.demand.winner && (this.orderStatus == 'UN_PAY' || this.orderStatus == 'OFFLINE_UN_CONFIRM')){
                this.processIndex = 1;
              } else if(this.orderStatus == 'UN_DESIGN'){
                this.processIndex = 2;
              } else if(this.orderStatus == 'UN_CONFIRM'){
                this.processIndex = 3;
              } else if(this.orderStatus == 'UN_APPRAISE'){
                this.processIndex = 4;
              } else if(this.orderStatus == 'FINISHED'){
                this.processIndex = 5;
              }

            });

          }
        });
      },
      getDemandList() {
        let param = {};
        if (this.isLogin) {
          param = {
            status:"SIMILAR",
            demandUuid:this.$route.params.uuid,
            demandType: this.demandType,
            current: this.pNo,
            pageSize: this.pSize,
            cates: this.demand.demandClassId,
            sort : "PUBLISH_TIME",
            order :"DESC",
            isLogin: 1
          };
        }else{
          param = {
            status:"SIMILAR",
            demandUuid:this.$route.params.uuid,
            demandType: this.demandType,
            current: this.pNo,
            pageSize: this.pSize,
            cates: this.demand.demandClassId,
            sort : "PUBLISH_TIME",
            order :"DESC",
            isLogin: 0
          };
        }
        similarDemandListByPage(param).then((res) => {
          let pages = 0;
          if (res != null && res.total > 0) {
            pages = Math.ceil(res.total / 4);
            if (this.pNo <= pages - 1) {
              this.pNo = this.pNo + 1;
            } else {
              this.pNo = 1;
            }
          }

          if (res != null && res.list != null && res.list.length > 0) {
            this.demandList = [];
            console.log(res);
            res.list.forEach((item, index) => {
              let demand = {};
              demand.uuid = item.uuid;
              demand.title = item.demandName;
              demand.money = item.lowPreAmount + "-" + item.highPreAmount;
              if (item.demandDes != null && item.demandDes != undefined) {
                demand.size = item.demandDes
                        .replace(/<[^>]+>/g, "")
                        .replace(/&nbsp;/gi, "");
              }
              if (item.demandType == "MODEL") {
                demand.describe =
                        item.specificationsStart + "~" + item.specificationsEnd + "cm";
              }
              demand.date = item.expectedDeliveryTime;
              this.demandList.push(demand);
              // }
            });
            console.log(this.demandList);
          }
        });
      },
      // 文件上传
      // 移除、点击 按钮 文件的信息
      handleRemove(file, fileList) {
        this.fileList = fileList;
      },
      // 预览文件
      handlePreview(file) {
        // console.log(file);
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      // 限制文件的个数
      // handleExceed(files, fileList) {
      //   this.$message.warning(
      //     `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
      //       files.length + fileList.length
      //     } 个文件`
      //   );
      // },
      handleAvatarSuccess(obj, fileList) {
        // console.log(obj);
        this.fileList.push(obj);
      },
      // 删除文件提示按钮
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`);
      },
      getDetailMessage(uuid) {
        let routeData = this.$router.resolve({
          name: "designDetails",
          params: { uuid: uuid },
        });
        window.open(routeData.href, "_blank");
      },
      demandOffer() {
        if (!this.isLogin) {
          this.$confirm("请先登录再提交需求报价", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
                  .then(() => {
                    this.$router.push("/login");
                  })
                  .catch(() => {
                    this.$message({
                      type: "info",
                      message: "取消提交需求报价",
                    });
                  });
        } else if ((this.userMessages.identity == 'ANONYMOUS' || this.userMessages.identity == 'PERSONAL') && this.designerType == ''){
          this.$confirm('您不是平台设计师，无法参与需求报价！', '提示', {
            confirmButtonText: '入驻平台设计师',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push('/designerIn')
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        } else if (this.userMessages.identity == 'ENTERPRISE'){
          this.$alert("您是平台企业用户，无法参与需求报价！", "提示", {
            confirmButtonText: "取消",
          });
        } else if (this.designerType == 'MODEL' && this.demandType != 'MODEL'){
          this.$alert("您是平台三维设计师，无法参与平面设计需求报价！", "提示", {
            confirmButtonText: "取消",
          });
          return;
        }  else if (this.designerType == 'GRAPHIC' && this.demandType == 'MODEL'){
          this.$alert("您是平台平面设计师，无法参与三维设计需求报价！", "提示", {
            confirmButtonText: "取消",
          });
          return;
        } else if(this.demand.creator == this.userMessages.uuid){
          this.$message({
            type: "info",
            message: "不能对自己发布的需求进行报价",
          });
          return;
        }else {
          merchantCurrent().then((res)=>{
            if(res.success&&res.data.applicationStatus!=='COMPLETED'){
              this.$message.error("您还未完成开户,请等待开户申请完成！");
              return false;
            }else if(res.success&&res.data.applicationStatus==='REVIEW_BACK'){
              this.$message.error("账号开户失败，请前往PC端设计师中心重新提交开户申请！");
              return false;
            }else if(!res.success) {
              this.$confirm('您还未进行开户，请前往设计师中心下进行账号开户！', '提示', {
                confirmButtonText: '账号开户',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                window.open(this.$url.designerWeb + '/#/accountManagement', "_blank");
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                });
              });
              return false;
            }else{
              // 开户完成
              this.saveDemandInfo();
            }
          });
          //this.saveDemandInfo();
        }
      },
      saveDemandInfo(){
        if (!this.offerForm.offer) {
          this.$alert("请填写需求报价", "提示", {
            confirmButtonText: "确定",
          });
          return;
        } else if (!this.offerForm.planDeliveryTime) {
          this.$alert("请选择计划工期", "提示", {
            confirmButtonText: "确定",
          });
          return;
        } else if (!this.offerForm.remark) {
          this.$alert("请填写报价说明", "提示", {
            confirmButtonText: "确定",
          });
          return;
          // }else if (this.fileList.length == 0) {
          //   this.$alert("请上传相关附件", "提示", {
          //     confirmButtonText: "确定",
          //   });
          //   return
        }

        let files = [];
        for (let i = 0; i < this.fileList.length; i++) {
          files.push({
            fileUrl: this.fileList[i].url,
            fileName: this.fileList[i].name,
            attachmentType: "OFFER",
          });
        }
        this.offerForm.designerAttachmentForDemands = files;
        this.offerForm.demandUuid = this.demand.uuid;
        this.offerForm.demandName = this.demand.demandName;
        this.offerForm.demandType = this.demand.demandType;
        this.offerForm.demandNo = this.demand.demandNo;
        this.offerForm.lowPreAmount = this.demand.lowPreAmount;
        this.offerForm.highPreAmount = this.demand.highPreAmount;
        this.offerForm.fileType = this.demand.fileType;
        this.offerForm.specificationsStart = this.demand.specificationsStart;
        this.offerForm.specificationsEnd = this.demand.specificationsEnd;
        this.offerForm.deadline = this.demand.deadline;
        this.offerForm.demandDes = this.demand.demandDes;
        this.offerForm.demandRemark = this.demand.remark;
        this.offerForm.publisherUuid = this.demand.creator;
        this.offerForm.publisher = this.demand.user.name;
        this.offerForm.createTime = this.demand.createTime;//将需求的创建时间暂时放入报价的创建时间
        this.$confirm("请确认报价信息，提交后将无法修改。", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
                .then(() => {
                  addDesignerOffer(this.offerForm).then((response) => {
                    // this.successBut = !response.success;
                    if (response.success) {
                      this.$message({
                        type: "success",
                        message: "提交成功!",
                        duration:1200,　　//显示时间, 毫秒。设为 0 则不会自动关闭，建议1200
                        onClose:()=>{
                          //跳转页面或执行方法
                          this.$router.go(0);
                        }
                      })
                    } else {
                      this.$message({
                        type: "error",
                        message: response.message,
                      });
                    }
                  });

                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消提交",
                  });
                });
      },
      getFilesUrl(fileUrl) {
        window.open(fileUrl);
      },
      hasLiked(){
        hasLiked(this.$route.params.uuid).then((res) => {
          this.like = res;
        })
      },
      liked(uuid) {
        if (this.isLogin) {
          if(this.demand.creator == this.userMessages.uuid){
            this.$message({
              type: "success",
              message: "不能收藏自己发布的需求！",
            });
            return ;
          }
          let params = {
            likeType: 'DEMAND',
            serviceType: 'LIKE',
            designerUuid: uuid,
          };
          like(params).then((res) => {
            if(res && res.success){
              this.getDetailInfo();
              this.hasLiked();
              this.$message({
                type: "success",
                message: res.message
              });
            }
          });
        } else {
          this.$message({
            type: "success",
            message: "您需要先登录哦！",
          });
          this.$router.push('/login')
        }
      },
      startChat() {
        let targetUserId = this.user.uuid;
        if (this.isLogin) {
          let user = this.$store.state.isUsermessage;
          getRongCloudUser(targetUserId).then(res=> {
            console.log('targetUserId-------' + targetUserId);
            console.log(res);
            this.$refs.chatDialogRef.init(user.uuid,user.name,user.headUrl,res.uuid,res.name,res.headUrl);
          });
        } else {
          this.$message({
            type: "success",
            message: "您需要先登录哦！",
          });
          this.$router.push('/login')
        }
      },
      saveNewsFabulous() {
        if (!this.$store.state.isLogin) {
          this.$message.error("用户未登陆")
          return false;
        }
        let param = {
          demandUuid: this.uuid,
          userId: this.userMessages.uuid,
        }
        saveDemandFabulous(param).then((response) => {
          this.$message.success(response.message);
          this.getDetailInfo();
        })
      },
      deleteNewsFabulous() {
        if (!this.$store.state.isLogin) {
          this.$message.error("用户未登陆")
          return false;
        }
        let param = {
          demandUuid: this.uuid,
          userId: this.userMessages.uuid,
        }
        deleteDemandFabulous(param).then((response) => {
          this.getDetailInfo();
        })
      },
      creatQrCode() {
        console.log(window.location.href);
        var qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: window.location.href, // 需要转换为二维码的内容
          width: 200,
          height: 200,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      },
    },

  };
</script>

<style scoped lang="less">
  @import "../../assets/dist/css/share.min.css";

  .wechat-qrcode{
    display: none !important;
  }
  .icon-wechat:before {
    content: "\F09A"!important;
  }


  .designRequirement {
    .currentPosition {
      font-size: 12px;
      color: #c9c9c9;
      padding-bottom: 15px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      span {
        color: #157efb;
      }
    }
    .titleContent {
      .designTitle {
        span {
          font-size: 12px;
          font-weight: 400;
          color: #c9c9c9;
          padding-left: 15px;
          vertical-align: middle;
        }
        .designTop{
          font-size: 18px;
          font-weight: bold;
          color: #262626;
          letter-spacing: 1px;
          padding: 0;
          max-width: 624px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
        }
        .designTitleContent {
          font-size: 18px;
          font-weight: bold;
          color: #262626;
          letter-spacing: 1px;
          padding: 0;
          max-width: 250px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
        }
      }
      .budget {
        padding: 29px 0 34px;
        font-size: 12px;
        color: #5a5a5a;
        align-items: center;
        .budgetOne {
          margin-right: 84px;
          .budgetOneP {
            width: 67px;
            height: 32px;
            background: #157efb;
            font-size: 16px;
            color: #fff;
            text-align: center;
            line-height: 32px;
          }
          .budgetOneP2 {
            // width: 113px;
            padding: 0 10px;
            height: 32px;
            line-height: 32px;
            box-sizing: border-box;
            border: 1px solid #157efb;
            font-size: 18px;
            line-height: 32px;
            text-align: center;

            color: #157efb;
          }
        }
        .budgetOne_mobile {
          margin-right: 50px;
        }
        .budgetLeft {
          p {
            margin-right: 21px;
          }
        }
      }
    }
    .quotedPrice {
      text-align: center;
      button {
        width: 105px;
        height: 30px;
        background: linear-gradient(180deg, #4377fa 0%, #606aff 100%);
        border-radius: 15px;
        font-size: 12px;
        color: #fff;
        border: none;
        cursor: pointer;
      }
      .isTimeOutButton {
        background: #ccc;
        cursor: not-allowed;
      }
      p {
        font-size: 9px;
        color: #c9c9c9;
        padding-top: 3px;
        margin-top: 32px;
        margin-bottom: 8px;

        span {
          font-size: 13px;
          margin: 0 4px;

          color: #157efb;
          font-weight: bold;
        }
      }
    }
    .left_top_mess {
      margin-top: 37px;
      color: #555;
      ul {
        display: flex;
        margin-right: 59px;
        flex-shrink: 0;
        li {
          display: flex;
          .stepNum {
            font-size: 9px;
            width: 22px;
            height: 22px;
            border-radius: 50%;
            text-align: center;
            line-height: 22px;
            color: #cccccc;
            border: 1px solid #cccccc;
            margin: 0 auto;
            box-sizing: border-box;
          }
          .stepName {
            font-size: 10px;
            color: #cccccc;
            padding-top: 8px;
          }
          .stepLine {
            width: 55px;
            height: 1px;
            background: #cccccc;
            margin-top: 11px;
          }
        }
        li.active {
          .stepNum {
            border: 1px solid #157efb;
            background: #157efb;
            color: #fff;
          }
          .stepName {
            color: #157efb;
          }
        }
      }
      .left_top_share {
        align-items: center;
        color: #c9c9c9;

        p {
          font-size: 12px !important;
          padding: 0;
          &:nth-last-of-type(1) {
            margin-left: 33px;
          }
          i{
            font-size: 22px;
            cursor: pointer;
          }
        }
      }
    }
    .left_top_mess2 {
      margin-top: 6px;
    }
    .payIcon {
      width: 39px;
      height: 39px;
      background: #ecf5ff;
      border-radius: 10px;
      margin-right: 10px;
      .payIconContent {
        width: 24px;
        height: 19px;
        color: #fff;
        background: #157efb;
        border-radius: 4px;
        margin: 8px auto 5px;
        font-size: 12px;
        text-align: center;
        line-height: 20px;
      }
      .payIconLine {
        width: 26px;
        height: 1px;
        background: #157efb;
        margin: 0 auto;
      }
    }
    .details_right {
      padding-top: 35px;
      width: 100%;
      .recommendedRequirements {
        padding: 20px 22px 0;
        background: #fff;
        border-radius: 10px;
        .requirementsTitle {
          display: flex;
          justify-content: space-between;
          .name {
            font-size: 18px;
            font-weight: bold;
            color: #157efb;
          }
          .refresh {
            font-size: 12px;
            cursor: pointer;
            color: #262626;
            //   line-height: 20px;
            display: flex;
            align-items: center;
            i {
              font-size: 18px;
              margin-left: 2px;
            }
          }
        }
        .requirementItem {
          padding: 24px 0;
          border-bottom: 2px solid #f5f5f5;
          &:last-child {
            border-bottom: none;
          }
          .rqTitle {
            font-size: 16px;
            font-weight: normal;
            color: rgba(0, 0, 0, 0.85);
            margin-bottom: 10px;
            width: 100%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          .rqPrice {
            margin: 10px 0 0;
            padding: 2px 0 20px;
            display: flex;
            span {
              display: block;
              box-sizing: border-box;
              text-align: center;
              line-height: 30px;
              font-size: 14px;
              &.tagBlue {
                width: 67px;
                height: 32px;
                color: #fff;
                background: #157efb;
                border: 1px solid #157efb;
              }
              &.tagName {
                // width: 113px;
                padding: 0 5px;
                height: 32px;
                color: #157efb;
                background: #fff;
                border: 1px solid #157efb;
                border-left: none;
              }
            }
          }
          .rqDetail {
            li {
              display: flex;
              padding-bottom: 8px;
              &:last-child {
                padding: 0;
              }
              .detailTitle {
                width: 70px;
                font-size: 13px;
                color: rgba(0, 0, 0, 0.85);
              }
              .detailContent {
                width: 240px;
                font-size: 13px;
                color: #808080;
              }
              .detailContent2 {
                display: -webkit-box;
                overflow: hidden;
                white-space: normal !important;
                text-overflow: ellipsis;
                word-wrap: break-word;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
              }
            }
          }
        }
      }
    }
  }

  .red {
    color: #d60000;
  }

  .details {
    width: 1200px;
    margin: 0 auto;
    padding-top: 20px;
    padding-bottom: 24px;
    .details_left {
      width: 816px;
      margin-right: 21px;
      flex-shrink: 0;

      .left_top {
        height: 202px;
        background: #fff;
        border-radius: 10px;
        padding: 30px 42px 30px 29px;
        margin-bottom: 20px;

        .left_top_title {
          justify-content: space-between;
          border-bottom: 1px solid #efefef;
        }
      }

      /*基本信息*/

      .left_center {
        padding: 21px 31px;
        background: #ffffff;
        border-radius: 10px;
        margin-bottom: 20px;
        background: #fff;
        .center_mess {
          margin-bottom: 36px;
          .basicInformation {
            .center_mess_box {
              width: 50%;
              margin-top: 20px;
              .mess_box_details {
                margin-top: 10px;
                margin-left: 5px;
              }
            }
          }
          .center_mess_title {
            font-size: 18px;
            color: #262626;
            font-weight: bold;
            margin-left: 5px;
          }

          .center_mess_box {
            .mess_box_title {
              font-size: 16px;
              color: #262626;
              font-weight: bold;
              align-items: center;

              i {
                display: inline-block;
                width: 2px;
                height: 16px;
                background: #157efb;
                margin-right: 4px;
                position: relative;
                //   top: 2px;
              }
            }
            .mess_box_details {
              align-items: center;
              margin-top: 15px;
              margin-left: 5px;

              p {
                color: #000;
                font-size: 14px;
                line-height: 20px;
              }

              i {
                display: inline-block;
                width: 1px;
                height: 16px;
                background: #555;
                margin: 0 10px;
              }
            }

            .mess_box_text {
              color: #157efb;
              font-size: 14px;
              margin-top: 15px;
              margin-left: 5px;

              p {
                align-content: center;
                display: flex;
                line-height: 20px;
                i {
                  font-size: 20px;
                }
              }
            }

            .mess_img {
              display: flex;
              align-items: center;
              margin-top: 14px;
            }
          }
        }
      }

      .left_bottom {
        font-size: 14px;
        color: #555;
        padding: 26px 36px;
        background: #fff;
        border-radius: 10px;
        /deep/.el-button--primary {
          background-color: #157efb;
          border-color: #157efb;
        }
        p {
          color: #000;
        }
        .left_bottom_title {
          font-size: 18px;
          font-weight: bold;
          color: #262626;
        }
        .bottom_input {
          margin-top: 10px;
          align-items: center;
          // font-size: 14px;
          .bottom_money {
            align-items: center;
            margin-right: 30px;

            input {
              border: 1px solid #ddd;
              border-radius: 5px;
              background: #fff;
              width: 108px;
              height: 30px;
              margin: 0 10px;
              padding-left: 10px;
            }
          }
        }
        .bottom_tex {
          margin-top: 10px;

          p {
            margin-right: 10px;
          }

          textarea {
            width: 80%;
            /*border: none;*/
            border-color: #ddd;
            background: #fff;
            border-radius: 5px;
            padding: 10px;
          }
        }
        .bottom_up {
          margin-top: 10px;

          align-items: flex-start;

          p {
            margin-right: 10px;
            margin-top: 6px;
          }

          .red {
            font-size: 12px;
          }
        }
        .upButton {
          margin-top: 30px;
          text-align: center;
          button {
            border: none;
            border-radius: 4px;
            height: 30px;
            width: 105px;
            background: linear-gradient(180deg, #4377fa 0%, #606aff 100%);
            color: #fff;
            font-size: 12px;
            cursor: pointer;
          }
        }
        // 参与报价设计师
        .join {
          display: flex;
          align-items: center;
          // justify-content: space-between;
          flex-wrap: wrap;
          margin-top: 20px;
          .join_box {
            flex-shrink: 0;
            background: #f3f3f39c;
            padding: 16px;
            box-sizing: border-box;
            border-radius: 10px;
            width: 32%;
            border: 1px solid #f3f3f39c;
            margin-right: 14px;
            cursor: pointer;
            margin-bottom: 10px;
            &:nth-of-type(3n+3){
              margin-right: 0;
            }
            .join_box_top {
              display: flex;
              .join_box_top_l {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                flex-shrink: 0;
                margin-right: 10px;
                img {
                  width: 100%;
                  height: 100%;
                  border-radius: 50%;
                }
              }
              .join_box_top_r {
                width: 100%;

                .join_box_top_user {
                  display: flex;
                  justify-content: space-between;
                  span {
                    font-size: 12px;
                    color: #157efb;
                    padding: 0 3px;
                    border-radius: 5px;
                    border: 1px solid #157efb;
                    flex-shrink: 0;
                  }
                  p {
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    width: 108px;
                  }
                }
                img {
                  height: 16px;
                  margin-top: 10px;
                }
              }
            }
            .join_box_top_mobile {
              display: block;
              text-align: center;
              .join_box_top_l {
                margin: 0 auto;
              }
              .join_box_top_r {
                .join_box_top_user {
                  display: block;
                  p {
                    width: auto;
                  }
                }
              }

            }
            .join_box_bottom {
              padding-top: 10px;
              border-top: 1px solid #dfdfdf;
              margin-top: 5px;
              display: flex;
              justify-content: space-between;
              font-size: 14px;
              .join_box_bottom_l,.join_box_bottom_r {
                p {
                  word-wrap:break-word
                }
              }
              .join_box_bottom_t {
                color: #666;
                margin-bottom: 5px;
              }
              .join_box_bottom_l {
                width: 45%;
              }
              .join_box_bottom_r {
                width: 55%;
              }
            }
          }
          .join_box_active {
            box-shadow: 0 0 11px -2px #a2cbff;
            border: 1px solid #a2cbff;
          }
        }
      }
    }

    .details_right {
      .right_mess {
        //   border: 1px solid #e3e3e3;
        border-radius: 4px;
        text-align: center;
        margin: 0 auto 20px;
        padding: 45px 0 20px;
        background: #fff;
        height: 197px;
        img {
          width: 97px;
          height: 97px;
          border-radius: 50%;
          background: #efefef;
        }

        .right_mess_names {
          margin-top: 10px;
          color: #000;
          font-size: 18px;
        }

        .right_mess_design {
          font-size: 14px;
          color: #555;
          margin: 13px 0;
        }

        button {
          cursor: pointer;
          border: 1px solid #157efb;
          border-radius: 4px;
          background: #fff;
          font-size: 12px;
          width: 90px;
          height: 32px;
          margin: 30px 0 20px;
          color: #157efb;
        }
      }

      .box-card {
        border: 1px solid #e3e3e3;
        margin-bottom: 30px;

        .rqTitle {
          font-size: 16px;
          font-weight: normal;
          color: rgba(0, 0, 0, 0.85);
          margin-bottom: 10px;
        }

        .rqPrice {
          font-size: 14px;
          color: #157efb;
          border: 1px solid #157efb;
          padding: 5px 20px 5px 70px;
          position: relative;
          width: fit-content;

          span.tagBlue {
            background-color: #157efb;
            color: #fff;
            font-size: 12px;
            width: 50px;
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .rqDetail {
          margin-top: 20px;
          dt {
            float: left;
            width: 70px;
            color: #000;
            font-size: 13px;
            font-weight: 400;
            text-align: right;
            line-height: 24px !important;
          }

          dd {
            color: #808080;
            font-size: 13px;
            line-height: 24px !important;
            margin-left: 80px;
            margin-bottom: 8px;
          }
        }

        .rqFooter {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #f1f5fe;
          border: 1px solid #e3e3e3;
          margin: 0 -21px -21px;
          position: relative;

          span {
            display: inline-block;
            width: 50%;
            text-align: center;
            font-size: 13px;
            height: 50px;
            line-height: 50px;
          }

          span a {
            color: #157efb;
          }

          span a:hover {
            color: rgba(21, 126, 251, 0.8);
          }

          :after {
            position: absolute;
            content: "";
            width: 1px;
            background-color: #e3e3e3;
            height: 34px;
            top: 8px;
            left: 50%;
          }
        }
      }
    }
  }
  .mess_box_detailshtml {
    /deep/img {
      max-width: 100% !important;
    }
  }
  .ql-editor {
    padding: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/design/designDetails.vue